export enum Env {
  // ci = 'ci',
  dev = "dev",
  local = "local",
  staging = "staging",
  production = "production",
  // qa1 = 'qa1',
  // qa2 = 'qa2',
  // qa3 = 'qa3',
  // qa4 = 'qa4',
  // qa5 = 'qa5',
  // qa6 = 'qa6',
}
